import { LegalPage, LegalSection } from "@/components/layout/LegalPage";
import { useCompanySettings } from "@/context/SettingsContext";

export default function CookiePolicyPage() {
  const { settings } = useCompanySettings();
  return (
    <LegalPage title="Cookie Policy" subtitle="Last updated: July 2026" testId="cookie-page">
      <LegalSection title="1. What Are Cookies & Local Storage">
        <p>
          Cookies are small text files stored on your device by websites. We primarily use browser local storage
          (a similar technology) to make the Platform work smoothly.
        </p>
      </LegalSection>
      <LegalSection title="2. What We Store">
        <ul className="list-disc list-inside space-y-1">
          <li><span className="font-medium text-foreground">Login session</span> — keeps you signed in securely after OTP verification.</li>
          <li><span className="font-medium text-foreground">Guest resume draft</span> — saves your unsaved Resume Builder work on your own device so you don't lose it.</li>
          <li><span className="font-medium text-foreground">Traffic source</span> — remembers how you found us (e.g. Instagram) to improve our outreach.</li>
        </ul>
      </LegalSection>
      <LegalSection title="3. What We Do NOT Use">
        <p>We do not use third-party advertising cookies, cross-site trackers or sell any browsing data.</p>
      </LegalSection>
      <LegalSection title="4. Managing Cookies">
        <p>
          You can clear local storage and cookies anytime from your browser settings. Note that clearing them will log you
          out and remove unsaved guest resume drafts.
        </p>
      </LegalSection>
      <LegalSection title="5. Contact">
        <p>Questions? Contact us at {settings.support_email || "our support email"}.</p>
      </LegalSection>
    </LegalPage>
  );
}
